const defaultProperties = {
  basic: {
    domain: null,
    timestamp: null,
    web_app_version: null,
    shopback_session_id: null,
  },
  channel: {
    utm_campaign: null,
    utm_source: null,
    utm_medium: null,
    utm_content: null,
    utm_term: null,
  },
  component: {
    ui_element_name: null,
    ui_element_type: null,
    ui_element_id: null,
  },
  object: {
    content_misc: null,
    content_name: null,
    content_position: null,
    content_type: null,
  },
  pageView: {
    screen_url: null,
    screen_name: null,
    screen_type: null,
  },
  redirect: {
    storeAffiliateId: null,
    shoppingTripUuid: null,
  },
  search: {
    searchKeyword: null,
    searchAction: null,
  },
  user: {
    accountUuid: null,
    has_adblock: null,
    has_extension: null,
  },
  error: {
    values: null,
    fields: null,
  }
}

module.exports = defaultProperties;